import { Component, OnInit, TemplateRef, ViewChild } from "@angular/core";
import { Router } from "@angular/router";
import { AppService } from "../services/app.service";
import { DatePipe } from "@angular/common";
import { environment } from "../../environments/environment";
import { BsModalService, BsModalRef } from "ngx-bootstrap/modal";
import { ToastrService } from "ngx-toastr";

@Component({
  selector: "app-schedule-review",
  templateUrl: "./schedule-review.component.html",
})
export class ScheduleReviewComponent implements OnInit {
  validationMessage: any;
  path: any;
  selectedlang: any;
  couldFrontURL = environment.cloudFrontURL;
  scheduleappointmentid: any = "";
  validateEmail = false;
  showExamdetails = false;
  countryCodeNew = "";
  medicalqnsList: any = [];
  scheduledpatient: any = {};
  scheduleDateShow: any;
  modalRef: BsModalRef;
  lat: number;
  lng: number;
  ratingForms: any = {
    review: "",
    rating: 0,
  };
  starRating: any;
  constructor(
    private appservice: AppService,
    private datepipe: DatePipe,
    private router: Router,
    private modalService: BsModalService,
    private toastr: ToastrService
  ) {}

  ngOnInit() {
    this.path = this.router.url;
    const Splitpath = this.path.split("/");
    if (Splitpath && Splitpath.length === 3) {
      this.scheduleappointmentid = Splitpath[2];
    }
    this.getscheduleappointmentId();
    if (localStorage.getItem("countryCodeNew")) {
      this.countryCodeNew = localStorage.getItem("countryCodeNew");
    }
  }

  getscheduleappointmentId() {
    this.viewpatient();
    this.getmedicalqns();
  }

  viewpatient() {
    this.appservice
      .viewscheduleappointment(this.scheduleappointmentid)
      .subscribe((res) => {
        if (res && res["status"] && res["status"]["status"] === 200) {
          if (res["entity"]) {
            this.scheduledpatient = res["entity"];
            this.lat = +this.scheduledpatient.latitude;
            this.lng = +this.scheduledpatient.longitude;
            this.scheduleDateShow = this.datepipe.transform(
              this.scheduledpatient.scheduledOn,
              "MMM d, y"
            );
          }
        }
      });
  }

  getmedicalqns() {
    this.appservice
      .getmedicalqns(this.scheduleappointmentid)
      .subscribe((res) => {
        if (res && res["entity"]) {
          this.medicalqnsList = res["entity"];
        }
      });
  }

  onRate(event) {
    this.ratingForms["rating"] = event["newValue"];
  }
  submit() {
    if (
      this.ratingForms &&
      this.ratingForms["rating"] &&
      this.ratingForms["review"]
    ) {
      this.ratingForms["scheduleAppointmentId"] = this.scheduleappointmentid;
      this.ratingForms["type"] = "patient";
      this.appservice.postReviews(this.ratingForms).subscribe((res: any) => {
        if (res && res.status && res.status.status === 200) {
          this.ratingForms = {
            review: "",
            rating: 0,
          };
          this.router.navigate(["/home"]);
        } else {
          this.toastr.error("Review update failed");
        }
      });
    } else {
      this.toastr.error("Please fill the all fields");
    }
  }
}
